<script>
  import { onMount } from 'svelte';
  import { nav, go } from './lib/nav.svelte.js';
  import { session, restore, mayVisit } from './lib/session.svelte.js';
  import { getHealth } from './lib/api.js';
  import Header from './components/Header.svelte';

  import Login from './routes/Login.svelte';
  import Account from './routes/Account.svelte';
  import Overview from './routes/Overview.svelte';
  import Dataset from './routes/Dataset.svelte';
  import DatasetNew from './routes/DatasetNew.svelte';
  import Advanced from './routes/Advanced.svelte';
  import Schemas from './routes/Schemas.svelte';
  import SourceIngest from './routes/SourceIngest.svelte';
  import Sources from './routes/Sources.svelte';
  import SourceMapping from './routes/SourceMapping.svelte';
  import Records from './routes/Records.svelte';
  import Partners from './routes/Partners.svelte';
  import PartnerDetails from './routes/PartnerDetails.svelte';
  import PartnerAccess from './routes/PartnerAccess.svelte';
  import PartnerConfirm from './routes/PartnerConfirm.svelte';
  import Catalog from './routes/Catalog.svelte';
  import CatalogNew from './routes/CatalogNew.svelte';
  import Queries from './routes/Queries.svelte';
  import Analysis from './routes/Analysis.svelte';

  const ROUTES = {
    login: Login,
    account: Account,
    overview: Overview,
    'data/dataset': Dataset,
    'dataset/new': DatasetNew,
    advanced: Advanced,
    schemas: Schemas,
    sources: Sources,
    'source/mapping': SourceMapping,
    'source/ingest': SourceIngest,
    records: Records,
    partners: Partners,
    partner: PartnerDetails,
    'partner/access': PartnerAccess,
    'partner/confirm': PartnerConfirm,
    catalog: Catalog,
    'catalog/new': CatalogNew,
    queries: Queries,
    analysis: Analysis,
  };

  let ready = $state(false);

  onMount(async () => {
    // Check the backend's held credential once at boot, so a stopped or
    // misconfigured API is reported on the sign-in screen rather than as a
    // confusing failure inside whatever screen happens to load first. Restore
    // the session and the Pod-resident presentation identity (brand, tagline,
    // title, accent) in the same round — a missing file or a down backend
    // falls back gracefully.
    const [health] = await Promise.allSettled([getHealth(), restore()]);
    if (health.status === 'fulfilled') session.health = health.value;
    else session.error = health.reason.message;
    ready = true;
  });

  // Sign-in gate: everything except the sign-in screen needs a session, and a
  // login only reaches the screens its roles cover.
  const Current = $derived.by(() => {
    if (!ready) return null;
    if (!session.user && nav.route !== 'login') {
      go('login');
      return Login;
    }
    if (session.user && nav.route === 'login') {
      go('overview');
      return Overview;
    }
    if (session.user && !mayVisit(nav.route)) {
      go('overview');
      return Overview;
    }
    return ROUTES[nav.route] ?? Overview;
  });
</script>

<div class="wf2-page">
  <div class="wf2-screen">
    <Header />
    {#if !ready}
      <div class="state"><span class="spinner"></span>Connecting to the app backend…</div>
    {:else}
      <Current />
    {/if}
  </div>
</div>
